import { App } from 'antd';
import { bindMessagingApi } from './messagingRegistry';

const AntMessagingBinder = () => {
  const app = App.useApp();
  bindMessagingApi({
    message: app.message,
    notification: app.notification,
    modal: app.modal,
  });
  return null;
};

export default AntMessagingBinder;
